export default class UnverifiedEmailError extends Error {
    constructor(message) {
        super(message);
        this.name = 'UnverifiedEmailError';
    }
}